/** @format */

import styled from "styled-components"
import { colorPalette } from "@ui-library/myslpro"
import SvgIconBuyMore from "@local/icons/component/IconBuyMore"
import SvgIconNoPost from "@local/icons/component/IconNoPost"
import { Popin } from "@ui-library/core"

export const StyledPopin = styled(Popin)`
	.content-wrapper {
		padding: 0px 0px 0px 0px;
	}
`

export const Body = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 0px 32px 48px;
	position: relative;

	.title {
		align-self: stretch;
		color: ${colorPalette.greyDark}
		font-family: "Source Sans Pro";
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 30px;
		text-align: center;
		margin: 0;
	}

	.text-wrapper {
		color: ${colorPalette.greyDark};
		font-family: "Source Sans Pro";
		font-size: 16px;
		font-weight: 600;
		line-height: 22px;
		text-align: center;
		width: 338px;
		text-align: center;
		margin: 0;
	}
`

export const IconBuyMore = styled(SvgIconBuyMore)`
	height: 192px;
	width: 203.17px;
`
export const IconNoPost = styled(SvgIconNoPost)`
	height: 140px;
	width: 163.99px;
`
